import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useLayoutStore } from '../../store/useLayoutStore';
import { cn } from '../../lib/cn';

export function SidebarCollapseButton() {
  const { sidebarCollapsed, toggleSidebar } = useLayoutStore();

  return (
    <button
      type="button"
      onClick={toggleSidebar}
      aria-label={sidebarCollapsed ? 'Déplier le menu' : 'Réduire le menu'}
      className={cn(
        'flex items-center justify-center w-full h-10 transition-colors',
        'text-cime-sidebar-text-muted hover:text-cime-sidebar-text hover:bg-cime-sidebar-active-bg',
        sidebarCollapsed ? 'px-0' : 'px-4 gap-2 text-sm',
      )}
    >
      {sidebarCollapsed ? (
        <ChevronRight className="w-4 h-4" aria-hidden />
      ) : (
        <>
          <ChevronLeft className="w-4 h-4" aria-hidden />
          <span>Réduire</span>
        </>
      )}
    </button>
  );
}
